import {ErrorMessage, Field, FieldArray, withFormik} from "formik";
import * as Yup from 'yup';
import React from "react";
import {AuthenticatedTemplate} from "@azure/msal-react";


export class EnquiryForm extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {
        const {
            submitCount,
            isValid,
            touched,
            handleChange,
            handleBlur,
            values,
            errors,
            handleSubmit,
            setFieldValue,
            setValues
        } = this.props;

        return submitCount === 1 ? (
            <div>
                <AuthenticatedTemplate>
                </AuthenticatedTemplate>

                <div className="page-title-sh26">
                    <h3>Thank you for your enquiry!</h3>
                </div>
                <hr/>
                <div className="page-section">
                    <p>You will receive an email confirmation of your submission. We will be in touch shortly.</p>
                </div>
            </div>
        ) : (
            <div>
                <AuthenticatedTemplate>
                </AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1 className="mb-2">Enquiry Form</h1>
                    <p>Make a new enquiry here</p>
                </div>
                <hr/>
                <div className="list-section">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <h3 className="mt-2">Your details</h3>
                                <div className="text-secondary mt-2 mb-2">Please enter your details so we can contact
                                    you.
                                </div>
                                <br/>
                                <div className="row">
                                    <div className="col-12 mb-2">
                                        <label htmlFor="name">Name:</label>
                                        <Field name="name" className="form-control"/>
                                        <ErrorMessage name="name" component="div" className="text-danger"/>
                                    </div>
                                    <div className="col-12 mb-2">
                                        {/* A TODO: check if company name is implemented in models */}
                                        <label htmlFor="companyName">Company Name:</label>
                                        <Field name="companyName" className="form-control"/>
                                        <ErrorMessage name="companyName" component="div" className="text-danger"/>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <label htmlFor="email">Email:</label>
                                        <Field name="email" type="email" className="form-control"/>
                                        <ErrorMessage name="email" component="div" className="text-danger"/>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <label htmlFor="phone">Phone:</label>
                                        <Field name="phone" type="tel" className="form-control"/>
                                        <ErrorMessage name="phone" component="div" className="text-danger"/>
                                    </div>
                                    <div className="col-12 mt-2 mb-4">
                                        <label htmlFor="message">Message (optional):</label>
                                        <Field name="message" as="textarea" className="form-control"/>
                                        <ErrorMessage name="message" component="div" className="text-danger"/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">

                                <FieldArray className="row mt-4" name="vehicles"
                                            render={arrayHelpers => (
                                                <div>
                                                    <div className="d-flex justify-content-between">
                                                        <div className="d-flex justify-content-between row mt-2 col-12">
                                                            <h3>Vehicles</h3>
                                                        </div>
                                                        <button className="btn btn-secondary no-padding" type="button"
                                                                onClick={() => arrayHelpers.push({
                                                                    make: "",
                                                                    model: "",
                                                                    licencePlate: "",
                                                                    comments: ""
                                                                })}>+
                                                        </button>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="text-secondary mb-2">Please specify all the
                                                                vehicles you are enquiring about.
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br/>
                                                    <div style={{
                                                        maxHeight: "70vh",
                                                        overflowY: "auto"
                                                    }}>
                                                        {values.vehicles.map((vehicle, index) => (
                                                            <div className="col-12 card mb-2" key={index}>
                                                                <div className="card-header">
                                                                    Vehicle {index + 1}
                                                                    {values.vehicles.length > 1 && <button type="button"
                                                                                                           className="btn btn-sm btn-primary float-end"
                                                                                                           aria-label="Close"
                                                                                                           onClick={() => arrayHelpers.remove(index)}>x</button>}
                                                                </div>
                                                                <div className="card-body">
                                                                    <div className="row mb-2">
                                                                        <div className="col-6">
                                                                            <label htmlFor="make">Make:</label>
                                                                            <Field name={`vehicles[${index}].make`}
                                                                                   className="form-control"/>
                                                                            <ErrorMessage
                                                                                name={`vehicles[${index}].make`}
                                                                                component="div"
                                                                                className="text-danger"/>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <label htmlFor="model">Model:</label>
                                                                            <Field name={`vehicles[${index}].model`}
                                                                                   className="form-control"/>
                                                                            <ErrorMessage
                                                                                name={`vehicles[${index}].model`}
                                                                                component="div"
                                                                                className="text-danger"/>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <div className="col-12">
                                                                            <label htmlFor="licencePlate">Licence
                                                                                Plate:</label>
                                                                            <Field
                                                                                name={`vehicles[${index}].licencePlate`}
                                                                                className="form-control"/>
                                                                            <ErrorMessage
                                                                                name={`vehicles[${index}].licencePlate`}
                                                                                component="div"
                                                                                className="text-danger"/>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <label htmlFor="comments">Comments:</label>
                                                                            <Field as="textarea"
                                                                                   name={`vehicles[${index}].comments`}
                                                                                   className="form-control"/>
                                                                            <ErrorMessage
                                                                                name={`vehicles[${index}].comments`}
                                                                                component="div"
                                                                                className="text-danger"/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                            )}
                                />
                            </div>
                        </div>
                        <div className="row mt-3 text-center">
                            <div>
                                <button className="btn btn-primary" type="submit" disabled={!isValid}>Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="page-break"></div>
            </div>

        )
    }
}

export default withFormik({
    enableReinitialize: true,
    mapPropsToValues: () => ({
        name: '',
        email: '',
        phone: '',
        message: '',
        vehicles: [
            {
                make: "",
                model: "",
                licencePlate: "",
                comments: ""
            }
        ]
    }),
    validationSchema: Yup.object().shape({
        name: Yup.string().required("Name is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        phone: Yup.string(),
        message: Yup.string(),
        vehicles: Yup.array().of(Yup.object().shape({
            make: Yup.string().required("Make is required"),
            model: Yup.string().required("Model is required"),
            licencePlate: Yup.string(),
            comments: Yup.string()
        }))
    }),
    validateOnMount: true,
    handleSubmit: async (values) => {
        const requestOptions = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(values)
        };
        // TODO: Get url dynamically
        const response = await fetch('http://localhost:3000/api/enquiries', requestOptions);
        const data = await response.json();
       
    }
})(EnquiryForm)
